export enum DIALOG_TYPE 
{
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD"
} 